<template>

  <head>

    <meta charset="utf-8" />
    <title>Desk Birdy | Business Permits</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Rental management system by Nouveta LTD" name="description" />
    <meta content="Kelvin Njuguna" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet"
          type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->

    <!-- owl.carousel css -->
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">

    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">

    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />

  </head>

  <body data-sidebar="dark">

  <!-- Begin page -->
  <div id="layout-wrapper">


    <!-- ========== Left Sidebar Start ========== -->
    <NavigationBar/>
    <!-- Left Sidebar End -->

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->



    <div class="main-content">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Construction Professionals</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Dashboard</a></li>
                    <li class="breadcrumb-item active">E Construction</li>
                    <li class="breadcrumb-item active">Proffessionals</li>
                  </ol>
                </div>

              </div>
            </div>
          </div>
          <!-- end page title -->
          <div class="row">
            <div class="col-12">
              <div class="card">

                <div class="card-body">
                  <div class="table-responsive">
                    <table
                        class="table align-middle table-striped table-nowrap table-hover dt-responsiv contacts-table"
                        id="datatable-buttons">
                      <thead class="table-dark">
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Registration Date</th>
                        <th scope="col">Registration Number</th>
                        <th scope="col">Professional Name</th>
                        <th scope="col">Profession</th>
                        <th scope="col">Governing Body</th>
                        <th scope="col">Sub County</th>
                        <th scope="col">Ward</th>
                        <th scope="col">Certification Status</th>
                        <th scope="col" class="text-right">Total Applications</th>
                        <th scope="col" class="text-right">Approved</th>
                        <th scope="col" class="text-right">Declined</th>
                        <th></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td class="text-capitalize">1.</td>
                        <td class="text-capitalize">2023-05-18</td>
                        <td>EBK/SE/2023/0045</td>
                        <td>Ochieng Okello</td>
                        <td>Structural Engineer</td>
                        <td>Engineers Board of Kenya</td>
                        <td>Homa Bay Town</td>
                        <td>Arujo</td>
                        <td><span class="badge bg-success">Active</span></td>
                        <td class="text-black text-uppercase text-right"><strong>12</strong>
                        </td>
                        <td class="text-black text-uppercase text-right">8</td>
                        <td class="text-black text-uppercase text-right">2</td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-primary btn-sm"
                                    data-bs-toggle="modal"
                                    data-bs-target="#professionalDetailsModal">View
                              Details</button>
                            <button class="btn btn-secondary btn-sm dropdown-toggle"
                                    type="button" data-bs-toggle="dropdown"
                                    aria-expanded="false"></button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="javascript: void(0);">Download
                                Certificate</a></li>
                              <div class="dropdown-divider"></div>
                              <li><a class="dropdown-item text-danger" href="javascript: void(0);"
                                     data-bs-toggle="modal"
                                     data-bs-target="#deactivateProfessionalModal">Deactivate</a>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-capitalize">2.</td>
                        <td class="text-capitalize">2023-05-20</td>
                        <td>AAK/ARCH/2022/0078</td>
                        <td>Adhiambo Nyambura</td>
                        <td>Architect</td>
                        <td>Architectural Association of Kenya</td>
                        <td>Ndhiwa</td>
                        <td>Kwabwai</td>
                        <td><span class="badge bg-warning">Pending Renewal</span></td>
                        <td class="text-black text-uppercase text-right"><strong>15</strong>
                        </td>
                        <td class="text-black text-uppercase text-right">10</td>
                        <td class="text-black text-uppercase text-right">3</td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-primary btn-sm"
                                    data-bs-toggle="modal"
                                    data-bs-target="#professionalDetailsModal">View
                              Details</button>
                            <button class="btn btn-secondary btn-sm dropdown-toggle"
                                    type="button" data-bs-toggle="dropdown"
                                    aria-expanded="false"></button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="javascript: void(0);">Download
                                Certificate</a></li>
                              <div class="dropdown-divider"></div>
                              <li><a class="dropdown-item text-danger" href="javascript: void(0);"
                                     data-bs-toggle="modal"
                                     data-bs-target="#deactivateProfessionalModal">Deactivate</a>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-capitalize">3.</td>
                        <td class="text-capitalize">2023-05-22</td>
                        <td>IEK/CE/2023/0112</td>
                        <td>Otieno Omolo</td>
                        <td>Civil Engineer</td>
                        <td>Institution of Engineers of Kenya</td>
                        <td>Oyugis</td>
                        <td>West Kasipul</td>
                        <td><span class="badge bg-danger">Inactive</span></td>
                        <td class="text-black text-uppercase text-right"><strong>7</strong>
                        </td>
                        <td class="text-black text-uppercase text-right">5</td>
                        <td class="text-black text-uppercase text-right">1</td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-primary btn-sm"
                                    data-bs-toggle="modal"
                                    data-bs-target="#professionalDetailsModal">View
                              Details</button>
                            <button class="btn btn-secondary btn-sm dropdown-toggle"
                                    type="button" data-bs-toggle="dropdown"
                                    aria-expanded="false"></button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="javascript: void(0);">Download
                                Certificate</a></li>
                              <div class="dropdown-divider"></div>
                              <li><a class="dropdown-item text-success" href="javascript: void(0);"
                                     data-bs-toggle="modal"
                                     data-bs-target="#activateProfessionalModal">Activate</a>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-capitalize">4.</td>
                        <td class="text-capitalize">2023-06-05</td>
                        <td>AAK/ARCH/2023/0056</td>
                        <td>Akinyi Odhiambo</td>
                        <td>Architect</td>
                        <td>Architectural Association of Kenya</td>
                        <td>Mbita</td>
                        <td>Gembe</td>
                        <td><span class="badge bg-warning">Pending Renewal</span></td>
                        <td class="text-black text-uppercase text-right"><strong>10</strong>
                        </td>
                        <td class="text-black text-uppercase text-right">7</td>
                        <td class="text-black text-uppercase text-right">2</td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-primary btn-sm"
                                    data-bs-toggle="modal"
                                    data-bs-target="#professionalDetailsModal">View
                              Details</button>
                            <button class="btn btn-secondary btn-sm dropdown-toggle"
                                    type="button" data-bs-toggle="dropdown"
                                    aria-expanded="false"></button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="javascript: void(0);">Download
                                Certificate</a></li>
                              <div class="dropdown-divider"></div>
                              <li><a class="dropdown-item text-danger" href="javascript: void(0);"
                                     data-bs-toggle="modal"
                                     data-bs-target="#deactivateProfessionalModal">Deactivate</a>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-capitalize">5.</td>
                        <td class="text-capitalize">2023-06-10</td>
                        <td>QSK/QS/2023/0089</td>
                        <td>Onyango Otieno</td>
                        <td>Quantity Surveyor</td>
                        <td>Quantity Surveyors of Kenya</td>
                        <td>Rangwe</td>
                        <td>Kagan</td>
                        <td><span class="badge bg-success">Active</span></td>
                        <td class="text-black text-uppercase text-right"><strong>15</strong>
                        </td>
                        <td class="text-black text-uppercase text-right">12</td>
                        <td class="text-black text-uppercase text-right">2</td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-primary btn-sm"
                                    data-bs-toggle="modal"
                                    data-bs-target="#professionalDetailsModal">View
                              Details</button>
                            <button class="btn btn-secondary btn-sm dropdown-toggle"
                                    type="button" data-bs-toggle="dropdown"
                                    aria-expanded="false"></button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="javascript: void(0);">Download
                                Certificate</a></li>
                              <div class="dropdown-divider"></div>
                              <li><a class="dropdown-item text-danger" href="javascript: void(0);"
                                     data-bs-toggle="modal"
                                     data-bs-target="#deactivateProfessionalModal">Deactivate</a>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-capitalize">6.</td>
                        <td class="text-capitalize">2023-06-15</td>
                        <td>EBK/SE/2023/0223</td>
                        <td>Adhiambo Awuor</td>
                        <td>Structural Engineer</td>
                        <td>Engineers Board of Kenya</td>
                        <td>Ndhiwa</td>
                        <td>Central Kasipul</td>
                        <td><span class="badge bg-success">Active</span></td>
                        <td class="text-black text-uppercase text-right"><strong>8</strong>
                        </td>
                        <td class="text-black text-uppercase text-right">6</td>
                        <td class="text-black text-uppercase text-right">1</td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-primary btn-sm"
                                    data-bs-toggle="modal"
                                    data-bs-target="#professionalDetailsModal">View
                              Details</button>
                            <button class="btn btn-secondary btn-sm dropdown-toggle"
                                    type="button" data-bs-toggle="dropdown"
                                    aria-expanded="false"></button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="javascript: void(0);">Download
                                Certificate</a></li>
                              <div class="dropdown-divider"></div>
                              <li><a class="dropdown-item text-danger" href="javascript: void(0);"
                                     data-bs-toggle="modal"
                                     data-bs-target="#deactivateProfessionalModal">Deactivate</a>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-capitalize">7.</td>
                        <td class="text-capitalize">2023-06-20</td>
                        <td>AAK/ARCH/2023/0112</td>
                        <td>Oduor Otieno</td>
                        <td>Architect</td>
                        <td>Architectural Association of Kenya</td>
                        <td>Homa Bay Town</td>
                        <td>Rodi Kopany</td>
                        <td><span class="badge bg-warning">Pending Renewal</span></td>
                        <td class="text-black text-uppercase text-right"><strong>12</strong>
                        </td>
                        <td class="text-black text-uppercase text-right">9</td>
                        <td class="text-black text-uppercase text-right">2</td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-primary btn-sm"
                                    data-bs-toggle="modal"
                                    data-bs-target="#professionalDetailsModal">View
                              Details</button>
                            <button class="btn btn-secondary btn-sm dropdown-toggle"
                                    type="button" data-bs-toggle="dropdown"
                                    aria-expanded="false"></button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="javascript: void(0);">Download
                                Certificate</a></li>
                              <div class="dropdown-divider"></div>
                              <li><a class="dropdown-item text-success" href="javascript: void(0);"
                                     data-bs-toggle="modal"
                                     data-bs-target="#activateProfessionalModal">Activate</a>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-capitalize">8.</td>
                        <td class="text-capitalize">2023-06-25</td>
                        <td>IEK/CE/2023/0245</td>
                        <td>Akoth Ochieng</td>
                        <td>Civil Engineer</td>
                        <td>Institution of Engineers of Kenya</td>
                        <td>Oyugis</td>
                        <td>East Kasipul</td>
                        <td><span class="badge bg-danger">Inactive</span></td>
                        <td class="text-black text-uppercase text-right"><strong>6</strong>
                        </td>
                        <td class="text-black text-uppercase text-right">4</td>
                        <td class="text-black text-uppercase text-right">1</td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-primary btn-sm"
                                    data-bs-toggle="modal"
                                    data-bs-target="#professionalDetailsModal">View
                              Details</button>
                            <button class="btn btn-secondary btn-sm dropdown-toggle"
                                    type="button" data-bs-toggle="dropdown"
                                    aria-expanded="false"></button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="javascript: void(0);">Download
                                Certificate</a></li>
                              <div class="dropdown-divider"></div>
                              <li><a class="dropdown-item text-success" href="javascript: void(0);"
                                     data-bs-toggle="modal"
                                     data-bs-target="#activateProfessionalModal">Activate</a>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-capitalize">9.</td>
                        <td class="text-capitalize">2023-07-01</td>
                        <td>QSK/QS/2023/0134</td>
                        <td>Otieno Jaoko</td>
                        <td>Quantity Surveyor</td>
                        <td>Quantity Surveyors of Kenya</td>
                        <td>Mbita</td>
                        <td>Mfangano</td>
                        <td><span class="badge bg-success">Active</span></td>
                        <td class="text-black text-uppercase text-right"><strong>14</strong>
                        </td>
                        <td class="text-black text-uppercase text-right">11</td>
                        <td class="text-black text-uppercase text-right">2</td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-primary btn-sm"
                                    data-bs-toggle="modal"
                                    data-bs-target="#professionalDetailsModal">View
                              Details</button>
                            <button class="btn btn-secondary btn-sm dropdown-toggle"
                                    type="button" data-bs-toggle="dropdown"
                                    aria-expanded="false"></button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="javascript: void(0);">Download
                                Certificate</a></li>
                              <div class="dropdown-divider"></div>
                              <li><a class="dropdown-item text-danger" href="javascript: void(0);"
                                     data-bs-toggle="modal"
                                     data-bs-target="#deactivateProfessionalModal">Deactivate</a>
                              </li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <!-- Deactivate Professional Modal -->
                    <div class="modal fade" id="deactivateProfessionalModal" tabindex="-1">
                      <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                          <div class="modal-header bg-danger text-white">
                            <h5 class="modal-title">Deactivate Professional</h5>
                            <button type="button" class="btn-close btn-close-white"
                                    data-bs-dismiss="modal"></button>
                          </div>
                          <div class="modal-body">
                            <form>
                              <div class="mb-3">
                                <label class="form-label">Professional Name</label>
                                <input type="text" class="form-control"
                                       value="Ochieng Okello" readonly>
                              </div>
                              <div class="mb-3">
                                <label class="form-label">Reason for Deactivation <span
                                    class="text-danger">*</span></label>
                                <select class="form-select" required>
                                  <option value="">Select Reason</option>
                                  <option>Professional Misconduct</option>
                                  <option>Expired Certification</option>
                                  <option>Disciplinary Action</option>
                                  <option>Incomplete Documentation</option>
                                  <option>Voluntary Suspension</option>
                                  <option>Other</option>
                                </select>
                              </div>
                              <div class="mb-3 d-none" id="otherReasonField">
                                <label class="form-label">Specify Other Reason <span
                                    class="text-danger">*</span></label>
                                <textarea class="form-control" rows="3"
                                          placeholder="Provide detailed explanation"></textarea>
                              </div>
                              <div class="mb-3">
                                <label class="form-label">Detailed Explanation <span
                                    class="text-danger">*</span></label>
                                <textarea class="form-control" rows="3" required
                                          placeholder="Provide a comprehensive explanation for deactivation"></textarea>
                              </div>
                              <div class="mb-3">
                                <label class="form-label">Approved By <span
                                    class="text-danger">*</span></label>
                                <input type="text" class="form-control" required
                                       placeholder="Enter name of approving authority">
                              </div>
                              <div class="mb-3">
                                <label class="form-label">Approver's Position <span
                                    class="text-danger">*</span></label>
                                <input type="text" class="form-control" required
                                       placeholder="Enter position of approving authority">
                              </div>
                              <div class="form-check mb-3">
                                <input class="form-check-input" type="checkbox"
                                       id="confirmDeactivation" required>
                                <label class="form-check-label"
                                       for="confirmDeactivation">
                                  I confirm that this deactivation is justified and
                                  follows due process
                                </label>
                              </div>
                            </form>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary"
                                    data-bs-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-danger">Deactivate
                              Professional</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Activate Professional Modal -->
                    <div class="modal fade" id="activateProfessionalModal" tabindex="-1">
                      <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                          <div class="modal-header bg-success text-white">
                            <h5 class="modal-title">Activate Professional</h5>
                            <button type="button" class="btn-close btn-close-white"
                                    data-bs-dismiss="modal"></button>
                          </div>
                          <div class="modal-body">
                            <form>
                              <div class="mb-3">
                                <label class="form-label">Professional Name</label>
                                <input type="text" class="form-control"
                                       value="Otieno Omolo" readonly>
                              </div>
                              <div class="mb-3">
                                <label class="form-label">Reason for Activation <span
                                    class="text-danger">*</span></label>
                                <select class="form-select" required>
                                  <option value="">Select Reason</option>
                                  <option>Resolved Previous Issues</option>
                                  <option>Documentation Updated</option>
                                  <option>Certification Renewed</option>
                                  <option>Disciplinary Action Completed</option>
                                  <option>Other</option>
                                </select>
                              </div>
                              <div class="mb-3 d-none" id="otherActivationReasonField">
                                <label class="form-label">Specify Other Reason <span
                                    class="text-danger">*</span></label>
                                <textarea class="form-control" rows="3"
                                          placeholder="Provide detailed explanation"></textarea>
                              </div>
                              <div class="mb-3">
                                <label class="form-label">Detailed Explanation <span
                                    class="text-danger">*</span></label>
                                <textarea class="form-control" rows="3" required
                                          placeholder="Provide a comprehensive explanation for activation"></textarea>
                              </div>
                              <div class="mb-3">
                                <label class="form-label">Approved By <span
                                    class="text-danger">*</span></label>
                                <input type="text" class="form-control" required
                                       placeholder="Enter name of approving authority">
                              </div>
                              <div class="mb-3">
                                <label class="form-label">Approver's Position <span
                                    class="text-danger">*</span></label>
                                <input type="text" class="form-control" required
                                       placeholder="Enter position of approving authority">
                              </div>
                              <div class="form-check mb-3">
                                <input class="form-check-input" type="checkbox"
                                       id="confirmActivation" required>
                                <label class="form-check-label" for="confirmActivation">
                                  I confirm that this activation is justified and
                                  follows due process
                                </label>
                              </div>
                            </form>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary"
                                    data-bs-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-success">Activate
                              Professional</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Professional Details Modal -->
                    <div class="modal fade" id="professionalDetailsModal" tabindex="-1">
                      <div class="modal-dialog modal-lg modal-dialog-centered">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title">Professional Details</h5>
                            <button type="button" class="btn-close btn-close-white"
                                    data-bs-dismiss="modal"></button>
                          </div>
                          <div class="modal-body">
                            <div class="row">
                              <div class="col-md-6">
                                <h6>Personal Information</h6>
                                <p><strong>Name:</strong> Ochieng Okello</p>
                                <p><strong>Profession:</strong> Structural Engineer</p>
                                <p><strong>Governing Body:</strong> Engineers Board of
                                  Kenya</p>
                              </div>
                              <div class="col-md-6">
                                <h6>Certificate Details</h6>
                                <p><strong>Registration Number:</strong> EBK/SE/2023/0045
                                </p>
                                <p><strong>Registration Date:</strong> 2023-02-15</p>
                                <p><strong>Certificate Expiry:</strong> 2024-12-31</p>
                              </div>
                            </div>
                            <div class="row mt-3">
                              <div class="col-12">
                                <h6>Contact Information</h6>
                                <p><strong>Email:</strong>
                                  ochieng.okello@engineering.com</p>
                                <p><strong>Phone:</strong> +254 720 123 456</p>
                                <p><strong>Location:</strong> Homa Bay</p>
                              </div>
                            </div>
                            <div class="row mt-3">
                              <div class="col-12">
                                <h6>Application Statistics</h6>
                                <div class="row">
                                  <div class="col-md-4">
                                    <div class="card text-center">
                                      <div
                                          class="card-body bg-success text-white">
                                        <h5 class="card-title">8</h5>
                                        <p class="card-text">Approved
                                          Applications</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="card text-center">
                                      <div class="card-body bg-danger text-white">
                                        <h5 class="card-title">2</h5>
                                        <p class="card-text">Declined
                                          Applications</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="card text-center">
                                      <div class="card-body bg-warning text-dark">
                                        <h5 class="card-title">2</h5>
                                        <p class="card-text">Pending
                                          Applications</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary"
                                    data-bs-dismiss="modal">Close</button>
                          </div>
                        </div>
                      </div>
                    </div>


                    <!-- Details Modals -->
                    <div class="modal fade" id="details-1" tabindex="-1" role="dialog"
                         aria-labelledby="details-1-label" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="details-1-label">Application
                              Details: BPA-2023-001</h5>
                            <button type="button" class="close" data-dismiss="modal"
                                    aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <!-- Application details content goes here -->
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary"
                                    data-dismiss="modal">Close</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal fade" id="details-2" tabindex="-1" role="dialog"
                         aria-labelledby="details-2-label" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="details-2-label">Application
                              Details: BPA-2023-002</h5>
                            <button type="button" class="close" data-dismiss="modal"
                                    aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <!-- Application details content goes here -->
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary"
                                    data-dismiss="modal">Close</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Your table code remains the same -->

                    <!-- Details Modals -->
                    <!-- Your table code remains the same -->

                    <!-- Details Modals -->
                    <!-- Your table code remains the same -->

                    <!-- Details Modals -->
                    <div class="modal fade" id="details-3" tabindex="-1" role="dialog"
                         aria-labelledby="details-1-label" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div class="modal-content">
                          <div class="modal-header ">
                            <h5 class="modal-title" id="details-1-label">Rejected
                              Application: BPA-2023-001</h5>
                            <button type="button" class="close text-white"
                                    data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <div class="alert alert-danger" role="alert">
                              <strong>Rejection Reason:</strong> Incomplete Environmental
                              Impact Assessment
                            </div>

                            <h6>Applicant Details</h6>
                            <p>
                              <strong>Name:</strong> John Doe<br>
                              <strong>Email:</strong> john.doe@example.com<br>
                              <strong>Phone:</strong> +254 (723) 456-7890
                            </p>

                            <h6>Project Details</h6>
                            <p>
                              <strong>Project Name:</strong> Proposed Residential
                              House<br>
                              <strong>Plot Number:</strong> LR 1234/567<br>
                              <strong>Development Type:</strong> New Buildings<br>
                              <strong>Site Location:</strong> Homa Bay Town, Arujo
                              Ward<br>
                              <strong>Sub County:</strong> Homa Bay Town<br>
                              <strong>Ward:</strong> Arujo
                            </p>

                            <h6>Rejection Details</h6>
                            <p>
                              <strong>Rejection Date:</strong> 2023-05-20<br>
                              <strong>Rejected By:</strong> John Doe (Senior Environmental
                              Officer)<br>
                              <strong>Department:</strong> Environmental Assessment Unit
                            </p>

                            <h6>Specific Deficiencies</h6>
                            <ul>
                              <li>Incomplete biodiversity impact analysis</li>
                              <li>Lack of comprehensive ecosystem assessment</li>
                              <li>Missing detailed mitigation strategies</li>
                              <li>Insufficient documentation on potential environmental
                                disruptions</li>
                            </ul>

                            <h6>Recommended Actions</h6>
                            <ol>
                              <li>Conduct a comprehensive environmental impact study</li>
                              <li>Engage local environmental experts</li>
                              <li>Provide detailed mitigation and conservation plans</li>
                              <li>Resubmit updated environmental documentation</li>
                            </ol>

                            <h6>Uploaded Documents</h6>
                            <ul class="text-muted">
                              <li><del>Architectural Drawings</del> (Insufficient detail)
                              </li>
                              <li><del>Structural Drawings</del> (Incomplete environmental
                                context)</li>
                              <li><del>Site Plan</del> (Lacks ecological assessment)</li>
                              <li>Title Deed</li>
                              <li>KRA PIN Certificate</li>
                            </ul>

                            <h6>Payment Details</h6>
                            <p>
                              <strong>Application Fee Paid:</strong> KES 5,000<br>
                              <strong>Payment Date:</strong> 2023-05-17<br>
                              <strong>Payment Status:</strong> Non-refundable processing
                              fee
                            </p>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary"
                                    data-dismiss="modal">Close</button>
                            <button type="button" class="btn btn-primary">Request
                              Clarification</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Similar modals for Application 2 and 3 -->
                    ...

                    <!-- Similar modals for Application 2 and 3 -->
                    ...

                    <!-- Similar modals for Application 2 and 3 -->
                    ...

                    <!-- Approval Modals -->
                    <div class="modal fade" id="approve-1" tabindex="-1" role="dialog"
                         aria-labelledby="approve-1-label" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="approve-1-label">Approve Application
                            </h5>
                            <button type="button" class="close" data-dismiss="modal"
                                    aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <form>
                              <div class="form-group">
                                <label for="approval-comments-1">Approval
                                  Comments</label>
                                <textarea class="form-control" id="approval-comments-1"
                                          rows="3"></textarea>
                              </div>
                            </form>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary"
                                    data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-success">Approve</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal fade" id="approve-2" tabindex="-1" role="dialog"
                         aria-labelledby="approve-2-label" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="approve-2-label">Approve Application
                            </h5>
                            <button type="button" class="close" data-dismiss="modal"
                                    aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <form>
                              <div class="form-group">
                                <label for="approval-comments-2">Approval
                                  Comments</label>
                                <textarea class="form-control" id="approval-comments-2"
                                          rows="3"></textarea>
                              </div>
                            </form>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary"
                                    data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-success">Approve</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal fade" id="approve-3" tabindex="-1" role="dialog"
                         aria-labelledby="approve-3-label" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="approve-3-label">Approve Application
                            </h5>
                            <button type="button" class="close" data-dismiss="modal"
                                    aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <form>
                              <div class="form-group">
                                <label for="approval-comments-3">Approval
                                  Comments</label>
                                <textarea class="form-control" id="approval-comments-3"
                                          rows="3"></textarea>
                              </div>
                            </form>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary"
                                    data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-success">Approve</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Decline Modals -->
                    <div class="modal fade" id="decline-1" tabindex="-1" role="dialog"
                         aria-labelledby="decline-1-label" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="decline-1-label">Decline Application
                            </h5>
                            <button type="button" class="close" data-dismiss="modal"
                                    aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <form>
                              <div class="form-group">
                                <label for="decline-reason-1">Reason for
                                  Declining</label>
                                <textarea class="form-control" id="decline-reason-1"
                                          rows="3" required></textarea>
                              </div>
                            </form>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary"
                                    data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-danger">Decline</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal fade" id="decline-2" tabindex="-1" role="dialog"
                         aria-labelledby="decline-2-label" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="decline-2-label">Decline Application
                            </h5>
                            <button type="button" class="close" data-dismiss="modal"
                                    aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <form>
                              <div class="form-group">
                                <label for="decline-reason-2">Reason for
                                  Declining</label>
                                <textarea class="form-control" id="decline-reason-2"
                                          rows="3" required></textarea>
                              </div>
                            </form>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary"
                                    data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-danger">Decline</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal fade" id="decline-3" tabindex="-1" role="dialog"
                         aria-labelledby="decline-3-label" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="decline-3-label">Decline Application
                            </h5>
                            <button type="button" class="close" data-dismiss="modal"
                                    aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <form>
                              <div class="form-group">
                                <label for="decline-reason-3">Reason for
                                  Declining</label>
                                <textarea class="form-control" id="decline-reason-3"
                                          rows="3" required></textarea>
                              </div>
                            </form>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary"
                                    data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-danger">Decline</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- end col -->
          </div>





        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->


      <!-- bootstrap modal -->
      <div class="modal fade" id="changeStream" tabindex="-1" role="dialog"
           aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLongTitle">Change Revenue Stream</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-lg-12">
                  <div>
                    <label class="form-label">Select New Revenue Stream</label>
                    <select class="form-control selectpicker bg-white" title="Select Revenue Stream"
                            data-live-search="true">
                      <option value=" ">Failing to carry and produce a driving license on demand.
                      </option>
                      <option value=" ">Exceeding speed limit prescribed for class of vehicle by
                        1-5 KPH</option>
                      <option value=" ">Exceeding speed limit prescribed for class of vehicle by
                        6-10 KPH</option>
                      <option value=" ">Exceeding speed limit prescribed for class of vehicle by
                        11-15 KPH</option>
                      <option value=" ">Exceeding speed limit prescribed for class of vehicle by
                        16-20 KPH</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary w-100 text-center">Save changes</button>
            </div>
          </div>
        </div>
      </div>
      <!-- end of changing revenue stream modal -->


      <footer class="footer ">
        <div class="container-fluid ">
          <div class="row ">
            <div class="col-sm-6 ">
            </div>
            <div class="col-sm-6 ">
              <div class="text-sm-end d-sm-block ">
                Best Birdy Billing system.
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>


    <!-- end main content-->



  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay "></div>

  </body>

</template>

<script>
/* eslint-disable */

import NavigationBar from "@/components/Navigation";

export default {
  name: "eConstructionStats",
  components: { NavigationBar},
  data() {
    return {

    }

  },
  watch: {
  },

  mounted() {


  },
  methods: {

  },
  computed:{

  }
}
</script>


<style scoped>

</style>